(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dwg-ugc-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.dwg-ugc');
    if (!sections.length) return;

    sections.forEach(function (root) {
      var tiles = root.querySelectorAll('[data-ugc-tile]');
      var modal = root.querySelector('[data-ugc-modal]');
      if (!modal) return;
      var modalVideo = modal.querySelector('[data-ugc-modal-video]');
      var modalStars = modal.querySelector('[data-ugc-modal-stars]');
      var modalQuote = modal.querySelector('[data-ugc-modal-quote]');
      var modalName = modal.querySelector('[data-ugc-modal-name]');
      var modalLocation = modal.querySelector('[data-ugc-modal-location]');
      var modalCta = modal.querySelector('[data-ugc-modal-cta]');
      var closeEls = modal.querySelectorAll('[data-ugc-close]');

      function starsMarkup(rating) {
        rating = parseInt(rating, 10) || 0;
        var out = '';
        for (var i = 1; i <= 5; i++) {
          if (i <= rating) {
            out += '<svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M10 1l2.6 5.6 6.1.7-4.5 4.2 1.2 6L10 14.7 4.6 17.5l1.2-6L1.3 7.3l6.1-.7L10 1z"/></svg>';
          } else {
            out += '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M10 1l2.6 5.6 6.1.7-4.5 4.2 1.2 6L10 14.7 4.6 17.5l1.2-6L1.3 7.3l6.1-.7L10 1z"/></svg>';
          }
        }
        return out;
      }

      function openModal(tile) {
        var data = tile.querySelector('[data-ugc-data] > div');
        if (!data) return;
        modalVideo.src = data.dataset.videoUrl || '';
        modalStars.innerHTML = starsMarkup(data.dataset.rating);
        modalQuote.textContent = data.dataset.quote || '';
        modalName.textContent = data.dataset.customer || '';
        modalLocation.textContent = data.dataset.location || '';
        var ctaUrl = data.dataset.productUrl || '';
        var ctaTitle = data.dataset.productTitle || '';
        if (ctaUrl && ctaTitle) {
          modalCta.href = ctaUrl;
          modalCta.textContent = 'SHOP ' + ctaTitle.toUpperCase() + ' →';
        } else {
          modalCta.href = '#';
          modalCta.textContent = '';
        }
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('dwg-ugc-open');
        var p = modalVideo.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }

      function closeModal() {
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('dwg-ugc-open');
        try {
          modalVideo.pause();
          modalVideo.removeAttribute('src');
          modalVideo.load();
        } catch (e) {}
      }

      tiles.forEach(function (tile) {
        var btn = tile.querySelector('[data-ugc-open]');
        if (btn) btn.addEventListener('click', function () { openModal(tile); });
      });

      closeEls.forEach(function (el) {
        el.addEventListener('click', function (e) { e.preventDefault(); closeModal(); });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
      });

      // Autoplay tile previews only when in view; pause when out.
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting) {
              var p = v.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } else {
              try { v.pause(); } catch (e) {}
            }
          });
        }, { threshold: 0.35 });
        root.querySelectorAll('[data-ugc-video]').forEach(function (v) { observer.observe(v); });
      } else {
        root.querySelectorAll('[data-ugc-video]').forEach(function (v) {
          var p = v.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dwg-ugc-teaser"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var teasers = document.querySelectorAll('.dwg-ugc-teaser');
    if (!teasers.length) return;
    teasers.forEach(function (root) {
      var videos = root.querySelectorAll('[data-ugct-video]');
      if (!videos.length) return;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting) {
              var p = v.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } else {
              try { v.pause(); } catch (e) {}
            }
          });
        }, { threshold: 0.35 });
        videos.forEach(function (v) { io.observe(v); });
      } else {
        videos.forEach(function (v) {
          var p = v.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  /* DWG: belt + suspenders — force every quick-add inside a product-recommendations
     section to use 'add' mode regardless of any later JS that flips it back to 'choose'. */
  (function () {
    function forceAddOn(el) {
      if (!el) return;
      el.querySelectorAll('quick-add-component').forEach(function (qa) {
        qa.setAttribute('data-quick-add-button', 'add');
      });
    }

    function init(root) {
      if (!root) return;
      forceAddOn(root);
      var observer = new MutationObserver(function () { forceAddOn(root); });
      observer.observe(root, { childList: true, subtree: true });
    }

    document.querySelectorAll('product-recommendations').forEach(init);

    // Also catch any product-recommendations elements added later (e.g. via section editor)
    var docObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) return;
          if (node.tagName && node.tagName.toLowerCase() === 'product-recommendations') {
            init(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('product-recommendations').forEach(init);
          }
        });
      });
    });
    docObserver.observe(document.body, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
